/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Edit_Marker_LabelInputs */



/**
* | output |
* | --- |
* | "Edit selected marker" |
*
* @param {Markers_Edit_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_edit_marker_label = /** @type {((inputs?: Markers_Edit_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Edit_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le marqueur selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählten Marker bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica il marcatore selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать выбранный маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar marcador seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑选定标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したマーカーを編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित मार्कर को संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar marcador selecionado")
	return /** @type {LocalizedString} */ ("Edit selected marker")
});